import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import useMarkJobAsPaidButtonProps from "components/job/JobLayout/JobActions/MarkJobAsPaidButton/useMarkJobAsPaidButtonProps";

export interface MarkJobAsPaidButtonProps {}

export const MarkJobAsPaidButton: FunctionComponent<
  MarkJobAsPaidButtonProps
> = () => {
  const { showContent, onClick, isSubmitting, isLoading } =
    useMarkJobAsPaidButtonProps();

  if (!showContent) {
    return <></>;
  }

  return (
    <Button.Text
      id="staff-mark-job-as-paid"
      onClick={onClick}
      label="Mark job as paid out"
      size={40}
      className="ml-6"
      isLoading={isLoading}
      disabled={isSubmitting}
    />
  );
};

export default MarkJobAsPaidButton;
